import React, { useState } from "react";
import styled, { createGlobalStyle } from "styled-components";
import Sidebar from "../components/Sidebar";
import Header from "../components/AppBar";
import Footer from "../components/Footer";

import { spacing } from "@material-ui/system";
import {
    Hidden,
    CssBaseline,
    Paper as MuiPaper,
    withWidth,
    Theme,
} from "@material-ui/core";

import { isWidthUp } from "@material-ui/core/withWidth";
import { Breakpoint } from "@material-ui/core/styles/createBreakpoints";
import AppContext from "../context/AppContext";
import _ from "lodash";
import { Subscription } from "../models/User";
import { Role } from "../models/Role";
import { sidebarLayoutRoutes as routes } from "../routes/index";
import Loader from "../components/Loader";

const drawerWidth = 258;

const GlobalStyle = createGlobalStyle`
  html,
  body,
  #root {
    height: 100%;
  }

  body {
    background: ${({ theme }: { theme: Theme }) =>
        theme.palette.background.default};
  }

  .MuiCardHeader-action .MuiIconButton-root {
    padding: 4px;
    width: 28px;
    height: 28px;
  }
`;

const Root = styled.div`
    display: flex;
    min-height: 100vh;
`;

const Drawer = styled.div`
    ${(props) => props.theme.breakpoints.up("md")} {
        width: ${drawerWidth}px;
        flex-shrink: 0;
    }
`;

const AppContent = styled.div`
    flex: 1;
    display: flex;
    flex-direction: column;
`;

const Paper = styled(MuiPaper)(spacing);

const MainContent = styled(Paper)`
    flex: 1;
    background: ${(props) => props.theme.palette.background.default};

    @media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
        flex: none;
    }

    .MuiPaper-root .MuiPaper-root {
        box-shadow: none;
    }
`;

const Dashboard = ({
    children,
    width,
}: {
    children: any;
    width: Breakpoint;
}) => {
    const [mobileOpen, setMobileOpen] = useState(false);
    const handleDrawerToggle = () => {
        setMobileOpen(!mobileOpen);
    };
    const appContext = React.useContext(AppContext);
    const { user } = appContext;

    const filteredRoutes = _.filter(routes, (r: any) => {
        const userSubscriptions = _.map(
            user?.subscriptions,
            (s: Subscription) => s.code
        );
        const isActive =
            user?.role === Role.Admin ||
            r.featureCodes == null ||
            r.featureCodes.find((f: string) =>
                userSubscriptions.find((us: string) => us === f)
            ) != null;
        return isActive;
    });

    if (user === null) {
        return <Loader />;
    }

    return (
        <Root>
            <CssBaseline />
            <GlobalStyle />
            <Drawer>
                <Hidden mdUp implementation="js">
                    <Sidebar
                        routes={filteredRoutes}
                        PaperProps={{ style: { width: drawerWidth } }}
                        variant="temporary"
                        open={mobileOpen}
                        onClose={handleDrawerToggle}
                    />
                </Hidden>
                <Hidden smDown implementation="css">
                    <Sidebar
                        routes={filteredRoutes}
                        PaperProps={{ style: { width: drawerWidth } }}
                    />
                </Hidden>
            </Drawer>
            <AppContent>
                <Header onDrawerToggle={handleDrawerToggle} />
                <MainContent p={isWidthUp("lg", width) ? 12 : 5}>
                    {children}
                </MainContent>
                <Footer />
            </AppContent>
        </Root>
    );
};

export default withWidth()(Dashboard);
